// @core/api/endpoints/notifications/get_user_settings_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserSettingsEventResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get user event-specific notification settings
 * Retrieves notification preferences for specific event types. Allows users to customize how they receive notifications for different activities.
 */
export async function GetUserSettingsEvent(
  user_id: string,
  options?: RequestOptions
): Promise<GetUserSettingsEventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/users/:user_id/settings/events`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<GetUserSettingsEventResponse>(requestPath, { ...requestOptions });
}
